var _circle, _path, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWomanBadge(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F8BBD0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 13.177C21 10.315 18.764 8 16 8s-5 2.315-5 5.177c0 2.54 1.764 4.64 4.09 5.082v1.976h-1.817v1.883h1.818V24h1.818v-1.882h1.818v-1.883H16.91V18.26C19.236 17.817 21 15.718 21 13.177zm-8.182 0c0-1.817 1.428-3.295 3.182-3.295 1.755 0 3.182 1.478 3.182 3.295 0 1.816-1.427 3.294-3.182 3.294s-3.182-1.478-3.182-3.294z",
    fill: "#27272A"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 12.5,
    stroke: "#18181B"
  })));
}
export default SvgWomanBadge;